import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import './Header.css';

const Header = ({
  title = 'placeholder',
  onClose = () => {},
}) => {
  const { t } = useI18n();
  
  return (
    <div className="room-settings-header">
      <span className="room-settings-header-title">{`${t('RoomSettings.title')} - ${title}`}</span>
      <button
        className="room-settings-header-close"
        onClick={onClose}
        aria-label={t('RoomSettings.closeButtonAriaLabel')}
      >
        ×
      </button>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
};

export default Header;
